import React from 'react';

import { useApp } from '../../store/AppContext';

export default function SidebarCollapseButton() {
  const { sidebarCollapsed, setSidebarCollapsed } = useApp();
  return sidebarCollapsed ? (
    <img
      src="/uptime-icon.svg"
      alt="Uptime"
      onClick={() => setSidebarCollapsed((v) => !v)}
      title="Déplier"
      className="h-[36px] cursor-pointer w-[auto]"
    />
  ) : (
    <>
      <img src="/uptime-logo-color.svg" alt="Uptime" className="h-[38px] [flex:1] w-[auto]" />
      <button
        onClick={() => setSidebarCollapsed((v) => !v)}
        title="Replier"
        className="flex items-center justify-center w-[26px] h-[26px] rounded-[7px] [border:1px_solid_#DCE5E7] bg-white cursor-pointer text-[#C5D0D4] shrink-0"
      >
        <i className="ti ti-chevron-left text-[13px]" aria-hidden="true" />
      </button>
    </>
  );
}
